module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-ThinItalic.26181bac.woff2";